// extracted by mini-css-extract-plugin
export default {"root":"DOQJV69dbxHrHV5EpTtf","operator":"rCeDjjTE_z82Oiia7isW","size-40":"WgJX8K0KH6v7nFftV46k","size-80":"mCx7VQuUsDmw6zrIj4ib"};